<template>
    
    <div>

        <!-- Profile Banner -->

        <div class="h-auto
                    bg-gray-100  
                    py-10
                    pt-32
                    px-10
                    rounded-cs-xl 
                    rounded-t-none 
                    relative" 
        
        >

            <div class="container mx-auto grid gap-6" >

                <h1 class="font-bold text-4xl" >Jane D.</h1>

                <p class="text-gray-600 font-normal" >janedoe@pogon.co</p>

                <div class="flex space-x-4" >

                    <button class="btn" >CHANGE PASSWORD</button>

                    <button class="btn" @click.prevent="logout" >LOGOUT</button>

                </div>

            </div>

        </div>

        <!-- Profile Body -->

        <div class="container m-auto flex space-x-20" >

            <div class="flex-grow py-10" >

                <div class="flex items-center" >

                    <div class="flex-grow" >

                        <p class="text-gray-600" >Modify and create users</p>

                        <h2 class="text-4xl font-bold" >Users</h2>

                    </div>

                    <button class="btn-primary" @click.prevent="userModal = true" >Add User</button>

                </div>

                <div class="mt-6" >

                    <div class="h-10 grid grid-cols-3 px-4 items-center bg-gray-100 rounded-cs-md rounded-b-none" >

                        <p class="text-xs text-gray-500" >Name</p>

                        <p class="text-xs text-gray-500" >Role</p>

                    </div>

                    <div :key="user.id" v-for="user in users" >

                        <div class="grid grid-cols-3 items-start p-4" >

                            <div>

                                <p>{{user.firstName}}</p>
                                <p class="text-xs text-gray-500" >{{user.email}}</p>

                            </div>

                            <p>{{user.role}}</p>

                            <div class="flex space-x-1 justify-end" >

                                <c-button 
            
                                class="mr-2"
                                title="Delete"
                                icon="/images/icons/delete.svg"
                                
                                />

                                <c-button 
                                
                                class="mr-4"
                                title="Edit"
                                icon="/images/icons/edit.svg"

                                @click="$router.push('/details')"
                                
                                />

                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <div class="flex-grow py-10" >

                <div class="flex items-center" >

                    <div class="flex-grow" >

                        <p class="text-gray-600" >Modify and create roles</p>

                        <h2 class="text-4xl font-bold" >Roles</h2>

                    </div>

                    <button class="btn-primary" >Add Role</button>

                </div>

            </div>

        </div>

        <new-user :open="userModal" @close="userModal = false" />

    </div>

</template>

<script>

    import { ref, computed } from 'vue'
    import { useStore } from 'vuex'
    import { useRouter } from 'vue-router'

    import cButton from '../components/button'
    import newUser from '../components/newuser'

    export default {
    
        name: 'Profile',

        components: { cButton, newUser },

        setup( props ) {

            const store = useStore()
            const router = useRouter()
            const users = computed(() => store.state.users.users )
            const roles = computed(() => store.state.users.roles )

            const userModal = ref(false)

            const logout = () => {

                localStorage.removeItem('token')
                store.commit( 'setAuth', null )
                router.push('/login')

            }

            return {
                users,
                roles,
                logout,
                userModal
            }

        }

    }

</script>